import {
  GetInvestmentMarket,
  GetInvestmentMarketList,
  GetInvestmentMarketWithAccountBroker,
  GetInvestmentMarketWithAccountBrokerList,
  GetMarketLoggedInForm,
  GetSingleMarketLoggedInList,
} from "./api";

import http from "config/http";

const marketApi = {
  getMarketLoggedInForm: async () => await http.get(GetMarketLoggedInForm),

  getInvestmentMarketList: async ({ brokerId, coinSourceId, coinDestinationId }) =>
    await http.get(GetInvestmentMarketList({ brokerId, coinSourceId, coinDestinationId })),

  getInvestmentMarketWithAccountBrokerList: async ({ brokerId, coinSourceId, coinDestinationId }) =>
    await http.get(GetInvestmentMarketWithAccountBrokerList({ brokerId, coinSourceId, coinDestinationId })),

  getInvestmentMarket: async ({ brokerId, coinSourceId, coinDestinationId }) =>
    await http.get(GetInvestmentMarket({ brokerId, coinSourceId, coinDestinationId })),

  getInvestmentMarketWithAccountBroker: async ({ brokerId, coinSourceId, coinDestinationId }) =>
    await http.get(GetInvestmentMarketWithAccountBroker({ brokerId, coinSourceId, coinDestinationId })),

  getSingleMarketLoggedInList: async ({ brokerId, coinDestinationId, coinSourceId }) =>
    await http.get(
      GetSingleMarketLoggedInList({
        coinSourceId,
        brokerId,
        coinDestinationId,
      })
    ),
};

export default marketApi;
